// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".style_input__fNnv0 {\n  width: 60%;\n  margin: 20px;\n}\n\n.style_button__Fkp7A {\n  margin: 100px 20px;\n}", "",{"version":3,"sources":["webpack://./src/containers/articles/articles/styles/style.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,YAAA;AACF;;AACA;EACE,kBAAA;AAEF","sourcesContent":[".input{\n  width: 60% ;\n  margin: 20px;\n}\n.button{\n  margin: 100px 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": "style_input__fNnv0",
	"button": "style_button__Fkp7A"
};
export default ___CSS_LOADER_EXPORT___;
